import React from "react";
import { Card } from "react-bootstrap";

const shimmer = {
  background:
    "linear-gradient(90deg,#f3f3f3 25%,#e8e8e8 50%,#f3f3f3 75%)",
  backgroundSize: "200% 100%",
  animation: "shimmer 1.5s infinite",
};

const SkeletonBox = ({
  width,
  height,
  radius = 8,
}: {
  width: string | number;
  height: string | number;
  radius?: number;
}) => (
  <div
    style={{
      width,
      height,
      borderRadius: radius,
      ...shimmer,
    }}
  />
);

const VideoLandingSkeleton = () => {
  return (
    <>
      <style>
        {`
          @keyframes shimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
          }
        `}
      </style>

      <main className="video-page-shell">
        {/* Header */}
        <div
          style={{
            backgroundColor: "rgb(255,237,188)",
            padding: "40px 10px 16px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
            }}
          >
            <SkeletonBox width={180} height={42} />
            <div style={{ marginTop: 15 }}>
              <SkeletonBox width={350} height={20} />
            </div>
          </div>
        </div>

        <div
          className="video-page-container"
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "20px 10px",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 360px",
              gap: "20px",
            }}
          >
            {/* LEFT SIDE */}
            <section>
              <Card
                style={{
                  borderRadius: 24,
                  border: "2px solid #efd2a2",
                  overflow: "hidden",
                }}
              >
                <Card.Body>
                  {/* Title */}
                  <SkeletonBox width="70%" height={34} />

                  {/* Video */}
                  <div style={{ marginTop: 20 }}>
                    <SkeletonBox
                      width="100%"
                      height={450}
                      radius={12}
                    />
                  </div>

                  {/* Author + Category */}
                  <div
                    style={{
                      display: "flex",
                      marginTop: 0,
                      padding: 20,
                      border: "1px solid #E8D1A5",
                      borderBottomLeftRadius: 12,
                      borderBottomRightRadius: 12,
                      gap: 20,
                    }}
                  >
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: 15,
                      }}
                    >
                      <SkeletonBox
                        width={55}
                        height={55}
                        radius={100}
                      />

                      <div>
                        <SkeletonBox width={100} height={18} />
                        <div style={{ marginTop: 8 }}>
                          <SkeletonBox width={140} height={20} />
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        width: 1,
                        background: "#eee",
                      }}
                    />

                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: 15,
                      }}
                    >
                      <SkeletonBox
                        width={55}
                        height={55}
                        radius={100}
                      />

                      <div>
                        <SkeletonBox width={100} height={18} />
                        <div style={{ marginTop: 8 }}>
                          <SkeletonBox width={140} height={20} />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Like Row */}
                  <div
                    style={{
                      marginTop: 15,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <SkeletonBox width={120} height={25} />
                    <SkeletonBox
                      width={35}
                      height={35}
                      radius={100}
                    />
                  </div>
                </Card.Body>
              </Card>

              {/* Description */}
              <Card
                style={{
                  marginTop: 20,
                  borderRadius: 20,
                  border: "2px solid #efd2a2",
                }}
              >
                <Card.Body>
                  <SkeletonBox width={160} height={26} />

                  <div style={{ marginTop: 20 }}>
                    <SkeletonBox width="100%" height={18} />
                    <div style={{ marginTop: 10 }}>
                      <SkeletonBox width="95%" height={18} />
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <SkeletonBox width="90%" height={18} />
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <SkeletonBox width="70%" height={18} />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </section>

            {/* RIGHT SIDE */}
            <aside>
              <Card
                style={{
                  borderRadius: 14,
                  border: "2px solid #efd2a2",
                  height: "780px",
                }}
              >
                <Card.Body>
                  <SkeletonBox width={180} height={26} />

                  <div style={{ marginTop: 20 }}>
                    {[1, 2, 3, 4, 5, 6].map((item) => (
                      <div
                        key={item}
                        style={{
                          display: "flex",
                          gap: 12,
                          marginBottom: 18,
                        }}
                      >
                        <SkeletonBox
                          width={120}
                          height={70}
                          radius={8}
                        />

                        <div style={{ flex: 1 }}>
                          <SkeletonBox
                            width="100%"
                            height={16}
                          />
                          <div style={{ marginTop: 8 }}>
                            <SkeletonBox
                              width="80%"
                              height={16}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </aside>
          </div>
        </div>
      </main>
    </>
  );
};

export default VideoLandingSkeleton;